export default __webpack_public_path__ + "sp.jpg?bcb558e2fb9300729cd02e74c2f061e6";